import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { enforceCanonicalHost } from "@/lib/canonical";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  const load = () => {
    api
      .get("/site")
      .then((r) => {
        setData(r.data);
        setFailed(false);
        enforceCanonicalHost(r.data?.settings);
      })
      .catch(() => setFailed(true));
  };

  useEffect(() => {
    load();
  }, []);

  const refresh = () => api.get("/site").then((r) => setData(r.data)).catch(() => {});

  return <SiteContext.Provider value={{ ...data, failed, refresh, reload: load }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
